import { render, staticRenderFns } from "./Sidebar-Child.vue?vue&type=template&id=0dd50c13&"
import script from "./Sidebar-Child.vue?vue&type=script&lang=js&"
export * from "./Sidebar-Child.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports